/**
 * 画像スライダー (旧 bt_image-slider 移植)
 *
 * 2つの動き方がある:
 *   - スワイプ式（既定。2026-10-27 からサイト全体）: 横スクロール (scroll-snap) で指で送れる。
 *     「3／5」の枚数表示と点を出す。chevron と点でも送れる。触ったら自動再生を止める。
 *     PostHog レビュー 2026-10-26 で「次へ」の連打が見つかった対応。見た目は blocks/image-slider/block.css の .is-swipe
 *   - フェード式（旧）: クロスフェードで .is-active を切り替え、5 秒ごとに自動で次へ。
 *     戻したいときは isSwipeMode() を false にする
 */

const AUTO_INTERVAL_MS = 5000;

function isSwipeMode() {
  return true;
}

function initFade(root, slides) {
  let current = 0;
  let timer = null;

  const show = (idx) => {
    const next = (idx + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle("is-active", i === next));
    current = next;
  };

  const start = () => {
    if (timer) return;
    timer = window.setInterval(() => show(current + 1), AUTO_INTERVAL_MS);
  };

  const stop = () => {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  };

  const prevBtn = root.querySelector("[data-image-slider-prev]");
  const nextBtn = root.querySelector("[data-image-slider-next]");
  if (prevBtn) prevBtn.addEventListener("click", () => { show(current - 1); stop(); start(); });
  if (nextBtn) nextBtn.addEventListener("click", () => { show(current + 1); stop(); start(); });

  // hover で一時停止 (PC のみ)
  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);
  // タブが非アクティブな間は止めて、戻ってきたら再開 (タブ非表示中は setInterval が不正確なので)
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else start();
  });

  start();
}

function initSwipe(root, list, slides) {
  root.classList.add("is-swipe");
  const count = slides.length;
  let current = 0;
  let timer = null;
  let touched = false;   // 一度でも触ったら自動再生はもう始めない

  // 枚数表示と点（JS で足す。JS が無いときは .is-swipe も付かず、これまでどおりフェード式の1枚目が出る）
  const meta = document.createElement("div");
  meta.className = "bt_image-slider__meta";
  const dots = document.createElement("ol");
  dots.className = "bt_image-slider__dots";
  const dotButtons = [];
  slides.forEach((_, i) => {
    const li = document.createElement("li");
    const b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", `${i + 1}枚目を表示`);
    b.addEventListener("click", () => { touch(); goTo(i); });
    li.appendChild(b);
    dots.appendChild(li);
    dotButtons.push(b);
  });
  const counter = document.createElement("span");
  counter.className = "bt_image-slider__counter";
  counter.setAttribute("aria-live", "polite");
  meta.append(dots, counter);
  root.appendChild(meta);

  const update = (idx) => {
    current = idx;
    slides.forEach((s, i) => s.classList.toggle("is-active", i === idx));
    dotButtons.forEach((b, i) => b.setAttribute("aria-current", i === idx ? "true" : "false"));
    counter.textContent = `${idx + 1}／${count}`;
  };

  // 自分で動かしているスクロール（ボタン・点・自動再生）と、指やトラックパッドで送られたものを区別する。
  // 自分で動かしている間は目標位置に着くまで programmatic を立てておく（smooth の途中で scroll が何度も来るため）
  let programmatic = false;
  let programmaticTarget = 0;
  const goTo = (idx) => {
    const next = (idx + count) % count;
    programmaticTarget = slides[next].offsetLeft;
    // すでにその位置なら scroll は起きないので、立てたままにしない
    programmatic = Math.abs(list.scrollLeft - programmaticTarget) >= 2;
    list.scrollTo({ left: programmaticTarget, behavior: "smooth" });
    update(next);
  };
  // 端末の回転・幅の変更・戻る操作での復元では scroll-snap が位置を合わせ直して scroll が起きるので、
  // その直後（と読み込み直後・自分で動かして着いた直後）は操作と見なさない
  let settleUntil = Date.now() + 600;
  const settle = () => { settleUntil = Date.now() + 600; };
  // スマホはアドレスバーの出入りでも resize が来るので、スライダーの幅が実際に変わったときだけ扱う
  let lastWidth = list.clientWidth;
  window.addEventListener("resize", () => {
    if (list.clientWidth === lastWidth) return;
    lastWidth = list.clientWidth;
    settle();
  }, { passive: true });
  window.addEventListener("pageshow", settle);
  window.addEventListener("popstate", settle);

  const indexFromPosition = () => {
    const width = list.clientWidth || 1;
    return Math.max(0, Math.min(count - 1, Math.round(list.scrollLeft / width)));
  };

  const stop = () => {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  };
  const start = () => {
    if (timer || touched) return;
    timer = window.setInterval(() => goTo(current + 1), AUTO_INTERVAL_MS);
  };
  const touch = () => { touched = true; stop(); };

  // 指やトラックパッドで横に送られたら、自動再生を止めてスクロール位置から今の枚数を出す。
  // 縦にページをスクロールしただけでは横の scroll は起きないので、ここで拾うのは横の操作だけ。
  let raf = 0;
  let settleTimer = 0;
  list.addEventListener("scroll", () => {
    window.cancelAnimationFrame(raf);
    window.clearTimeout(settleTimer);
    raf = window.requestAnimationFrame(() => {
      if (programmatic) {
        // 自分で動かしている途中。途中の位置から枚数を出すと表示が行き来し、連打のときに
        // 進む先もずれるので、目標に着いたときだけ下ろして位置から出し直す
        if (Math.abs(list.scrollLeft - programmaticTarget) < 2) {
          programmatic = false;
          settle();   // 着いた直後に scroll-snap が出す微調整の scroll を、操作と見なさない
          update(indexFromPosition());
        }
        return;
      }
      if (Date.now() > settleUntil) touch();
      const idx = indexFromPosition();
      if (idx !== current) update(idx);
    });
    // スクロールが止まったのに目標に着いていなければ、途中で指に奪われたと見なして操作扱いにする
    settleTimer = window.setTimeout(() => {
      if (!programmatic) return;
      programmatic = false;
      if (Math.abs(list.scrollLeft - programmaticTarget) >= 2) {
        touch();
        update(indexFromPosition());
      }
    }, 200);
  }, { passive: true });

  const prevBtn = root.querySelector("[data-image-slider-prev]");
  const nextBtn = root.querySelector("[data-image-slider-next]");
  if (prevBtn) prevBtn.addEventListener("click", () => { touch(); goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener("click", () => { touch(); goTo(current + 1); });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else start();
  });

  update(0);
  start();
}

function initOne(root) {
  const list = root.querySelector(".bt_image-slider__list");
  const slides = root.querySelectorAll(".bt_image-slider__slide");
  if (!list || slides.length < 2) return; // 1 枚以下なら自動再生不要

  if (isSwipeMode()) initSwipe(root, list, slides);
  else initFade(root, slides);
}

export function initImageSlider() {
  document.querySelectorAll("[data-image-slider]").forEach(initOne);
}
